(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('product-stretch-badge')) return;

  var observedTargets = new Map();
  var observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var badges = observedTargets.get(entry.target);
      observedTargets.delete(entry.target);
      observer.unobserve(entry.target);
      if (!badges) return;
      badges.forEach(function (badge) {
        badge.observationTarget = null;
        badge.loadStretch();
      });
    });
  }, { rootMargin: '200px' }) : null;

  class ProductStretchBadge extends HTMLElement {
    static get observedAttributes() { return ['data-style-no']; }

    connectedCallback() {
      this.reset();
    }

    disconnectedCallback() {
      this.requestVersion++;
      window.clearTimeout(this.retryTimer);
      this.stopObserving();
    }

    attributeChangedCallback() {
      if (this.isConnected) this.reset();
    }

    reset() {
      this.requestVersion = (this.requestVersion || 0) + 1;
      this.hidden = true;
      this.retryCount = 0;
      window.clearTimeout(this.retryTimer);
      this.stopObserving();
      if (this.dataset.styleNo && this.dataset.styleNo.trim()) this.observe();
    }

    observe() {
      if (!this.isConnected) return;
      if (!observer || !this.parentElement) {
        this.loadStretch();
        return;
      }
      var target = this.closest('.product-item__image-wrapper') || this.parentElement;
      var badges = observedTargets.get(target);
      if (!badges) {
        badges = new Set();
        observedTargets.set(target, badges);
        observer.observe(target);
      }
      badges.add(this);
      this.observationTarget = target;
    }

    stopObserving() {
      var target = this.observationTarget;
      if (!target) return;
      var badges = observedTargets.get(target);
      if (badges) {
        badges.delete(this);
        if (!badges.size) {
          observedTargets.delete(target);
          observer.unobserve(target);
        }
      }
      this.observationTarget = null;
    }

    loadStretch() {
      if (!this.isConnected || !window.EPSizeChart) return;
      var version = this.requestVersion;
      window.EPSizeChart.getStretch(this.dataset.styleNo).then((stretch) => {
        if (!this.isConnected || this.requestVersion !== version) return;
        this.hidden = stretch !== 'High Stretch' && stretch !== '高弹';
      }).catch(() => {
        if (!this.isConnected || this.requestVersion !== version) return;
        this.hidden = true;
        if (this.retryCount < 1) {
          this.retryCount++;
          this.retryTimer = window.setTimeout(() => this.observe(), 31000);
        }
      });
    }
  }

  window.customElements.define('product-stretch-badge', ProductStretchBadge);
})();
